/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      // console.log( Geofli );
      $( document ).ready( function() {
        const sectionId = 'shop';
        const targetElement = document.getElementById( sectionId );
        if ( window.location.href.includes( `#${sectionId}` ) && targetElement ) {
          const observer = new MutationObserver( function() {
            targetElement.scrollIntoView( {behavior: 'smooth', block: 'start'} );
            observer.disconnect();
          } );
          observer.observe( targetElement, {childList: true, subtree: true} );
        }
      } );

      function sanitizeTitle( title ) {
        title = title.toLowerCase();
        title = title.replace( /\s+/g, '-' );
        title = title.replace( /[^a-z0-9-]/g, '' );
        return title;
      }

      const usersStoredLocationStoreName = localStorage.getItem( 'locationStoreName' );
      if ( usersStoredLocationStoreName !== null ) {
        $( '.selected-location' ).text( usersStoredLocationStoreName );
        $( '.shop-link' ).attr( 'href', '/'+sanitizeTitle( usersStoredLocationStoreName )+'-menu' );
      } else {
        const storeId = $( '.user-store-selector[data-geofli-id="'+Geofli.stores[0].id+'"]' );
        const locationId = $( storeId ).attr( 'data-location-id' );
        const postName = $( storeId ).attr( 'data-location' );
        const locationState = $( storeId ).attr( 'data-specials-state' );
        const storedLocationId = localStorage.getItem( 'locationId' );
        const ogValue = $( '.specials-link' ).attr( 'href' );

        localStorage.setItem( 'locationId', locationId );
        localStorage.setItem( 'locationState', locationState );
        localStorage.setItem( 'locationStoreName', postName );
        $( '.user-store-selector[data-location-id="'+storedLocationId+'"]' ).addClass( 'bg-brand-neon' );
        $( '.selected-location' ).text( postName );
        $( '.shop-link' ).attr( 'href', '/'+sanitizeTitle( postName )+'-menu' );
        $( '.specials-link' ).attr( 'href', ogValue+'?state='+locationState );
      }

      const storedState = localStorage.getItem( 'locationState' );
      if ( storedState !== null ) {
        const ogValue = $( '.specials-link' ).attr( 'href' );
        $( '.specials-link' ).attr( 'href', ogValue+'?state='+storedState );
      }
      const usersStoredLocationId = localStorage.getItem( 'locationId' );
      if ( usersStoredLocationId !== null ) {
        $( '.user-store-selector' ).removeClass( 'bg-brand-neon' );
        $( '.user-store-selector[data-location-id="'+usersStoredLocationId+'"]' ).addClass( 'bg-brand-neon' );
      }

      $( document ).on( 'click', '.user-store-selector', function( e ) {
        e.preventDefault();
        $( '.user-store-selector' ).removeClass( 'bg-brand-neon' );
        const locationId = $( this ).attr( 'data-location-id' );
        const postName = $( this ).attr( 'data-location' );
        const locationState = $( this ).attr( 'data-specials-state' );

        localStorage.setItem( 'locationId', locationId );
        localStorage.setItem( 'locationState', locationState );
        localStorage.setItem( 'locationStoreName', postName );

        const storedLocationId = localStorage.getItem( 'locationId' );
        $( '.user-store-selector[data-location-id="' + storedLocationId + '"]' )
            .addClass( 'bg-brand-neon' );
        $( '.selected-location' ).text( postName );
        $( '.shop-link' ).attr( 'href', '/' + sanitizeTitle( postName ) + '-menu' );

        const baseSpecialsHref = $( '.specials-link' )
            .attr( 'href' )
            .split( '?' )[0];
        $( '.specials-link' )
            .attr( 'href', baseSpecialsHref + '?state=' + locationState );

        window.location.href = $( '.shop-link' ).attr( 'href' );
      } );

      $( '.ll-geofli-item' ).each( function( e ) {
        const distance = $( this ).find( '.store-distance' );
        const geofliId = $( this ).attr( 'data-geofli-id' );
        const filteredStore = $.grep( Geofli.stores, function( e ) {
          return e.id == geofliId;
        } );
        const distanceText = filteredStore.length ? filteredStore[0] : false;
        if ( distanceText ) {
          $( this ).attr( 'data-distance', distanceText.distance.miles );
          distance.text( distanceText.distance.formatted.miles );
        } else {
          $( this ).attr( 'data-distance', Infinity );
          distance.text( 'N/A' );
        }
        sortLocationsList();
      } );

      function sortLocationsList() {
        const ul = $( '.locations-list' );
        const sortedItems = ul.children( 'li' ).sort( function( a, b ) {
          const distanceA = parseFloat( $( a ).data( 'distance' ) );
          const distanceB = parseFloat( $( b ).data( 'distance' ) );
          return distanceA - distanceB;
        } );

        ul.empty().append( sortedItems );
      }


      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      if ( $( '.specials-archive' ) ) {
        const categoryButtons = $( '.category-button' );
        categoryButtons.each( function() {
          $( this ).on( 'click', function( e ) {
            e.preventDefault();
            const categoryId = $( this ).data( 'category' );
            const categoryCity = $( this ).closest( '.state-specials' );
            const closestButtons = categoryCity.find( '.category-button' );
            const allButton = categoryCity.find( '.all-button' );
            const categoryCards = categoryCity.find( '.category-card' );
            closestButtons.each( function() {
              $( this ).removeClass( 'bg-white text-brand-leaf active' ).addClass( 'text-brand-light-gray' );
              allButton.removeClass( 'bg-white text-brand-leaf active' ).addClass( 'text-brand-light-gray' );
            } );
            $( this ).addClass( 'bg-white text-brand-leaf active' ).removeClass( 'text-brand-light-gray' );
            if ( $( this ).hasClass( 'all-button' ) ) {
              categoryCards.each( function() {
                $( this ).addClass( 'active' ).show();
              } );
            } else {
              categoryCards.each( function() {
                const cssClass = 'cat-' + categoryId;
                if ( $( this ).hasClass( cssClass ) ) {
                  $( this ).addClass( 'active' ).show();
                } else {
                  $( this ).removeClass( 'active' ).hide();
                }
              } );
            }
          } );
        } );
      }

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
      if ( $( '#specials-state-slider' ).length > 0 ) {
        const splide = new Splide( '#specials-state-slider', {
          type: 'slide',
          drag: true, // Enable drag
          pagination: false,
          autoWidth: true,
          arrows: false,
        } );
        splide.mount();
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
